import { Component } from '@angular/core';

@Component({
  selector: 'mtm-highlight-icon',
  templateUrl: './highlight-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class HighlightIconComponent {}
